import {createContext} from 'react';
import {UserProfile} from "./security/UserProfile";
import {ResearcherStatus} from "../researcher/model/ResearcherStatus";

export interface UserProfileResponse {
  userName: string;
  roles: number[];
  researcherStatus?: ResearcherStatus;
  hasSignedUpViaInvitation: boolean;
}

// Define the shape of the context data
export interface AppContextProps {
  currentPage: string;
  userProfile: UserProfile;
}

let contextValue: AppContextProps = {
  currentPage: '',
  userProfile: new UserProfile(),
}

// Create the context with a default value
const AppContext = createContext<AppContextProps | undefined>(contextValue);

export default AppContext;